import { ApiKeysFilter, OrgTypes } from '@mode/shared/contract-common';
import { ModeForm, PaginationTypes } from '@mode/shared/contract-common';
import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as ApiKeyActions from './api-key.actions';

export const apiKeyFeatureKey = 'workspaceSettingsApiKeys';

export interface ApiKeysState {
  memberUsername: string | null;
  apiKeys: OrgTypes.ApiKey[] | null;
  apiKeysFilter: ApiKeysFilter | null;
  apiKeyCreateForm: ModeForm | undefined | null;
  memberApiKeysEnabled: boolean;
  pagination: PaginationTypes.Pagination;
  isLoading: boolean;
  query: string;
}

export const apiKeysInitialState: ApiKeysState = {
  apiKeys: null,
  apiKeysFilter: null,
  apiKeyCreateForm: null,
  memberApiKeysEnabled: false,
  memberUsername: null,
  pagination: {
    page: 0,
    per_page: 0,
    count: 0,
    total_pages: 0,
    total_count: 0,
  },
  isLoading: false,
  query: '',
};

export const apiKeysReducer = createReducer(
  apiKeysInitialState.apiKeys,
  on(ApiKeyActions.loadApiKeysSuccess, ApiKeyActions.loadMemberApiKeysSuccess, (state, action) => action.apiKeys)
);

export const apiKeysFilterReducer = createReducer(
  apiKeysInitialState.apiKeysFilter,
  on(ApiKeyActions.loadApiKeys, (state, action) => action.filter),
  on(ApiKeyActions.loadMemberApiKeys, (state, action) => null)
);

export const createFormReducer = createReducer(
  apiKeysInitialState.apiKeyCreateForm,
  on(
    ApiKeyActions.loadApiKeysSuccess,
    ApiKeyActions.loadMemberApiKeysSuccess,
    (state, action) => action.apiKeyCreateForm
  )
);

export const paginationReducer = createReducer(
  apiKeysInitialState.pagination,
  on(ApiKeyActions.loadApiKeysSuccess, ApiKeyActions.loadMemberApiKeysSuccess, (state, action) => action.pagination)
);

export const isLoadingReducer = createReducer(
  apiKeysInitialState.isLoading,
  on(ApiKeyActions.loadApiKeys, ApiKeyActions.loadMemberApiKeys, (state) => true),
  on(ApiKeyActions.loadApiKeysSuccess, ApiKeyActions.loadMemberApiKeysSuccess, (state, action) => false),
  on(ApiKeyActions.loadApiKeysFailure, ApiKeyActions.loadMemberApiKeysFailure, (state, action) => false)
);

export const queryReducer = createReducer(
  apiKeysInitialState.query,
  on(ApiKeyActions.loadApiKeys, ApiKeyActions.loadMemberApiKeys, (state, action) => action.query)
);

export const memberUsernameReducer = createReducer(
  apiKeysInitialState.memberUsername,
  on(ApiKeyActions.loadMemberApiKeys, (state, action) => action.memberUsername),
  // reset member username when other api keys are loaded
  on(ApiKeyActions.loadApiKeysSuccess, (state, action) => null)
);

export const memberApiKeysEnabledReducer = createReducer(
  apiKeysInitialState.memberApiKeysEnabled,
  on(ApiKeyActions.updateMemberApiKeysEnabledSuccess, (state, action) => !!action.enabled),
  on(ApiKeyActions.loadMemberApiKeysEnabledSuccess, (state, action) => action.enabled)
);

export const reducer: ActionReducerMap<ApiKeysState> = {
  apiKeys: apiKeysReducer,
  apiKeysFilter: apiKeysFilterReducer,
  apiKeyCreateForm: createFormReducer,
  memberApiKeysEnabled: memberApiKeysEnabledReducer,
  memberUsername: memberUsernameReducer,
  pagination: paginationReducer,
  isLoading: isLoadingReducer,
  query: queryReducer,
};
